import React, { Component } from "react";
import PropTypes from "prop-types";
import AppHelper from "../model/AppHelper";
import SlickImage from "../container/SlickImage";
import "./FlashcardItem.css";

export class FlashcardImage extends Component {
  static propTypes = {
    pageItem: PropTypes.object.isRequired,
    onLoadComplete: PropTypes.func
  }

  static defaultProps = {
    onLoadComplete: () => {}
  }

  componentDidMount(){
    const { onLoadComplete, pageItem } = this.props;
    const img = document.createElement('img');
    img.onload = function(){ onLoadComplete(pageItem) }
    img.onerror = function(){ onLoadComplete(pageItem) }
    img.src = pageItem.getImageUrl();
  }

  render() {
    const { pageItem } = this.props;
    const imageUrl = AppHelper.formatUrl(pageItem.getImageUrl());
    return !pageItem.isVertical() ?
        <div className={`flashcard-page-item image-item`}>
          { imageUrl == "" ? ("") : (
            <SlickImage ctrCls="preview-image" imageUrl={imageUrl} />
          )}
        </div>
        : <div className={`flashcard-page-item fullscreen`}
               style={{backgroundImage: `url("${imageUrl}")`}}></div>
    ;
  }
}

export default FlashcardImage;
